import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import { useFormSubmit } from "melco-shared-logic";
import { DisplayAddIntegrationForm } from "./DisplayAddIntergrationForm";
import { useAddIntegrationKey } from "../../hooks/settings/useAddIntegration";

type AddIntegrationForm = {
    name?: string;
    partner?: string;
    url?: string;
};

type AddIntegrationDrawerProps = {
    isDrawerOpen: boolean;
    setDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const AddIntegrationDrawer: React.FC<AddIntegrationDrawerProps> = ({
    isDrawerOpen,
    setDrawerOpen,
}) => {
    const { t } = useTranslation();

    const [addIntegration, isLoading] = useAddIntegrationKey();

    const initialValues: AddIntegrationForm = {
        name: "",
        partner: "",
        url: "",
    };

    const onSubmit = useFormSubmit<AddIntegrationForm>(
        async (values: AddIntegrationForm) => {
            const { name, partner, url } = values;

            await addIntegration(partner, name, url);

            setDrawerOpen(false);

            return { successMessages: [{ message: "default" }] };
        },
        {
            translationPrefix: "eodsettings.actions.add",
            onSuccess: (_values, { resetForm }) => {
                resetForm({ values: initialValues });
            },
        }
    );

    return (
        <Drawer
            title={t("eodsettings.actions.add.title")}
            placement="right"
            width={1000}
            closable={true}
            onClose={() => setDrawerOpen(false)}
            open={isDrawerOpen}
        >
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validateOnBlur={false}
                validateOnChange={false}
            >
                <DisplayAddIntegrationForm isLoading={isLoading} />
            </Formik>
        </Drawer>
    );
};
